import {request} from './request'
const brandApi={
// 首页模块-新闻列表
  homeModel:params=>{
    // return request('/ShowApi/GetList',params)
    return request({url: '/BrandApi/GetList',params:params});
  },

  //品牌列表
  getList:params=>{
    return request({url: '/BrandApi/GetList',params:params});
  },

  //单一内容
  getOneById:params=>{
    return request({url: '/BrandApi/GetById',params:params,});
  },

  //获取置顶的品牌列表
  getTopBrand:params=>{
    return request({url: '/BrandApi/GetTopList',params:params,});
  }


}
export default brandApi